export const campaignConfig = {
    campaignListConfig: 'campaign_devapp', // campaign_devapp
    campaignSearchListConfig: 'campaign_bbl_exclusive',
};

export const dashboardConfig = {
    mainDashboard: '',
    gameDashboard: 'bblprivilege_mission_jumping',
    surveyDashboard: 'bblprivilege_mission_survey',
    transactionDashboard: '',
    gamePuzzleDashboard: 'bblprivilege_mission_puzzle',
    gameMatchDashboard: 'bbl_mission_match',
};

export const categoryConfig = {
    menuCategory: 'menu_devapp',
    menuHomeCategory: 'menu_bbl_exclusive',
};

export const historyConfig = {
    purchase: 'purchase',
};

export const couponConfig = {
    coupon: 'coupon_config',
};
